import React, { Component } from "react";
import Header from "../layout/headerHome";
import Footer from "../layout/footerUpdated";
import { Helmet } from "react-helmet";

const aboutbg = require("./../../assets/images/background/newmedia-bg.webp");

class News extends Component {
    constructor(props) {
        super(props);
        this.state = {
            news: [],
            categories: [],
            selectedCategory: "all",
            currentPage: 1,
            newsPerPage: 9,
        };
    }

    componentDidMount() {
    document.title = "News & Media | Bridge Health";
    this.fetchNewsData();
    this.fetchCategories();
    }

    fetchNewsData = () => {
    const siteUrl = "https://admin.bridgehealth.in";

    fetch(
        `${siteUrl}/api/news-medias?pagination[start]=0&pagination[limit]=999999&sort=PublishedDate:desc&populate=*`
    )
        .then((response) => response.json())
        .then((data) => {
            const news = data.data.map((item) => ({
                id: item.id,
                title: item.attributes.Title,
                link: item.attributes.Link,
                image: item.attributes.Image?.data?.attributes?.url,
                publishedDate: item.attributes.PublishedDate,
                publishingSite: item.attributes.PublishingSite,
                category:
                item.attributes.media_category?.data?.attributes?.Slug ||
                item.attributes.media_category?.data?.attributes?.Name ||
                "",
            }));

            console.log("News Data:", news);

            this.setState({ news });
        })
        .catch((error) => console.error(error));
    };

    fetchCategories = () => {
    fetch(
        "https://admin.bridgehealth.in/api/media-categories"
    )
        .then((res) => res.json())
        .then((data) => {
            console.log("Category Data:", data.data);
            this.setState({
                categories: data.data,
            });
        });
    };

    handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber }, () => {
            window.scrollTo({ top: 400, behavior: "smooth" });
        });
    };

    render() {
        const {
            currentPage,
            newsPerPage,
            news,
            categories,
            selectedCategory,
        } = this.state;

        const filteredNews =
            selectedCategory === "all"
                ? news
                : news.filter((item) =>
                    item.category
                        ?.toLowerCase()
                        .trim() ===
                    selectedCategory
                        ?.toLowerCase()
                        .trim()
                );

        const indexOfLastNews = currentPage * newsPerPage;
        const indexOfFirstNews = indexOfLastNews - newsPerPage;

        const currentNews = filteredNews.slice(
            indexOfFirstNews,
            indexOfLastNews
        );

        const totalPages = Math.ceil(
            filteredNews.length / newsPerPage
        );

        return (
            <>
                <Header />
                <Helmet>
                    <title>
                        Latest Health Media and News on preventive care, Corporate wellness | Bridge
                        Health
                    </title>
                    <meta
                        name="News & Media"
                        content="Explore our informative blog for the latest articles & insights on health, wellness, & medical advancements. Stay informed & empowered with Bridge Health's blog."
                    />
                </Helmet>
                {/* Page Banner Section */}
                <section className="page-bann-media" style={{ backgroundImage: `url(${aboutbg})`, backgroundSize: "cover" }}>
                    <h1 className="colorwhite outline">NEWS & MEDIA</h1>
                </section>

                {/* News Section */}
                <section className="news-section p-5">
                    <div className="row">

                        {/* Left Sidebar */}

                        <div className="col-lg-3">

                            <div className="category-box">

                                <h3 className="category-heading">
                                    SELECT CATEGORY
                                </h3>

                                <ul className="category-list">

                                    <li
                                        className={
                                            selectedCategory === "all"
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() =>
                                            this.setState({
                                                selectedCategory: "all",
                                                currentPage: 1,
                                            })
                                        }
                                    >
                                        All Categories
                                    </li>

                                    {Array.isArray(categories) &&
                                        categories.map((cat) => (
                                        <li
                                            key={cat.id}
                                            className={`category-item ${
                                                selectedCategory === (cat.attributes.Slug || cat.attributes.Name)
                                                    ? "active"
                                                    : ""
                                            }`}
                                            onClick={() =>
                                                this.setState({
                                                    selectedCategory: cat.attributes.Slug || cat.attributes.Name,
                                                    currentPage: 1,
                                                })
                                            }
                                        >
                                            {cat.attributes.Name}
                                        </li>
                                    ))}

                                </ul>

                            </div>

                        </div>

                        {/* Right Side */}

                        <div className="col-lg-9">

                            <div className="row">

                                {currentNews.map((item) => (
                                    <div className="col-lg-6 mb-5" key={item.id}>

                                        <div className="news-card">

                                            <a
                                                href={item.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="news-link"
                                            >

                                                <div className="news-image-wrap">

                                                    <img
                                                        src={`https://admin.bridgehealth.in${item.image}`}
                                                        alt={item.title}
                                                        className="news-image"
                                                    />

                                                    <div className="publishing-site">
                                                        {item.publishingSite}
                                                    </div>

                                                </div>

                                                <div className="news-content">

                                                    <p className="news-date">
                                                        {new Date(
                                                            item.publishedDate
                                                        ).toLocaleDateString(
                                                            "en-IN",
                                                            {
                                                                weekday: "long",
                                                                day: "2-digit",
                                                                month: "long",
                                                                year: "numeric",
                                                            }
                                                        )}
                                                    </p>

                                                    <h4 className="news-title">
                                                        {item.title}
                                                    </h4>

                                                    <div className="news-btn-wrap">
                                                        <span className="news-btn">
                                                            READ MORE
                                                        </span>
                                                    </div>

                                                </div>

                                            </a>

                                        </div>

                                    </div>
                                ))}

                            </div>

                        </div>

                    </div>
                </section>

                {totalPages > 1 && (
                    <div className="pagination-wrap text-center mt-4">
                        <button
                            className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
                            onClick={() => currentPage > 1 && this.handlePageChange(currentPage - 1)}
                        >
                            Prev
                        </button>

                        {Array.from({ length: totalPages }).map((_, index) => (
                            <button
                                key={index + 1}
                                onClick={() => this.handlePageChange(index + 1)}
                                className={`pagination-btn ${
                                    currentPage === index + 1 ? "active" : ""
                                }`}
                            >
                                {index + 1}
                            </button>
                        ))}

                        <button
                            className={`pagination-btn ${
                                currentPage === totalPages ? "disabled" : ""
                            }`}
                            onClick={() =>
                                currentPage < totalPages &&
                                this.handlePageChange(currentPage + 1)
                            }
                        >
                            Next
                        </button>
                    </div>
                )}

                <Footer />
            </>
        );
    }
}

export default News;
